import { inject } from 'vue';
import type PodcastPlayer from './player';

export const podcastPlayerKey = Symbol.for('podcastPlayer');

export default function(): PodcastPlayer {
  return inject<PodcastPlayer>(podcastPlayerKey)!;
}
